import ConvertToString from "../../../../components/Converter";
import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";

function TotalPileLength({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.totalPileLength")}</p>}
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      indicesValue={
        <span>
          L<sub>tot</sub>
        </span>
      }
      unitValue={<span>m</span>}
    />
  );
}

export default TotalPileLength;
